import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class SendMailContactService {

  constructor(
    private http: HttpClient
  ) { }

  sendMail(correo_: string, nombre_: string, celular_: string
    , asunto_: string, mensajeContacto_: string) {
    const body ={
      key: "CONTACTO",
      value: correo_.toString(),
      correo:{
        placeholders:{
          nombre: nombre_.toString(),
          correo: correo_.toString(),
          celular: celular_.toString(),
          asunto: asunto_.toString(),
          mensajeContacto: mensajeContacto_.toString(),
        }
      }
    };

    const headers = new HttpHeaders({ 'Authorization':`Bearer ${localStorage.getItem('tokenId')}`, 'Content-Type':'application/json' });

    return this.http.post(`https://www.mundofinanciera.com:9091/api/mf/sendMailContact`, body, { headers, observe: 'response' });
  }
}
